export default () => {
  const loadVideo = videoElement => {
    try {
      const sources = videoElement.querySelectorAll('source');
      sources.forEach(source => {
        if (source.dataset.src) {
          source.src = source.dataset.src;
        }
      });
      videoElement.load();
      videoElement.classList.remove('lazy');
    } catch (error) {
      console.error('Error loading lazy video:', error);
    }
  };
  const initLazyVideos = () => {
    const lazyVideos = Array.from(document.querySelectorAll('video'));
    if (!('IntersectionObserver' in window)) {
      // Fallback for browsers that don't support IntersectionObserver
      lazyVideos.forEach(loadVideo);
      return;
    }
    const lazyVideoObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          lazyVideoObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '50px'
    });
    lazyVideos.forEach(video => lazyVideoObserver.observe(video));
  };

  // Wait for DOM to be fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyVideos);
  } else {
    initLazyVideos();
  }
};